// This file is autogenerated. Any changes will be overwritten.

export const set = 'streamline';

export const name = 'script';

export const Component = () => (
  <g fill='none' stroke='currentColor' strokeLinecap='round' strokeLinejoin='round'>
    <path d='M5.256 3.384h1.656m-1.08 2.808h4.464M5.832 9h4.464m-4.464 2.808h4.464m-4.464 2.808h2.232m6.12-14.04h1.152c.648 0 1.152.504 1.152 1.152v3.168c0 .432-.36.72-.72.72h-2.592v-3.96c-.072-.576.36-1.08 1.008-1.08z' />
    <path d='M14.832.576H5.256a2.243 2.243 0 0 0-2.232 2.232V14.04c0 2.232-1.152 2.88-2.232 3.384h9a3.38 3.38 0 0 0 3.384-3.384V5.616' />
  </g>
);

export const viewBox = '0 0 18 18';
